// extracted by mini-css-extract-plugin
export default {"feedback-dialog":"qBKcpBr0XR8obJQ","nps":"XrhjvCqdFwUhnaQ","ces":"rKEMGrZW5e7YRCo","csat":"CELd1GIaj4GK8uI","loader-overlay":"cVIFZpA3ZJPQbhA"};